export let patientRequestEn: Record<string, any> = {
    request_list: 'List of requests',
};
